<div class="status-container"
     [class.waiting]="status === statusEnum.Waiting"
     [class.refused]="status === statusEnum.Refused"
     [class.approved]="status === statusEnum.Approved || status === statusEnum.Imported">
  <i class="far"
     [class.fa-star]="status === statusEnum.New"
     [class.fa-clock]="status === statusEnum.Waiting"
     [class.fa-times-circle]="status === statusEnum.Refused"
     [class.fa-check-circle]="status === statusEnum.Approved || status === statusEnum.Imported"></i>
  {{ status | enumLabel: "STATUS" | translate }}
</div>
